<style>
#layersJoinModal .v--modal-box.v--modal {
  min-height: 375px !important;
  min-width: 560px !important;
}
#layersJoinModal * {
  font-size: 12px;
}
#layersJoinModal .checkbox--big i {
  font-size: 20px;
}
</style>

<template>
  <Modal
    modalName="layersJoinModal"
    title="Złączenia warstw użytkownika"
    @opened="opened()"
    v-if="userLayers"
    :buttons="[]"
  >
    <v-flex xs12>
      <span style="display: flex; width: 100%">
        <v-subheader class="font--primary">Złączenia</v-subheader>
        <span class="group">
          <v-icon
            style="font-size:20px; margin-top:3px;"
            class="btn__subheader"
            @click="show('layersJoinOptionsModal')"
            title="Dodaj złączenie"
          >
            add_circle_outline
          </v-icon>
        </span>
      </span>
      <v-list>
        <v-list-tile class="list--el">
          <v-list-tile-title class="list--el--bold">Nazwa warstwy</v-list-tile-title>
          <v-list-tile-title class="list--el--bold">Nazwa tabeli</v-list-tile-title>
          <v-list-tile-title class="list--el--bold">Nazwa pola warstwy</v-list-tile-title>
          <v-list-tile-title class="list--el--bold">Nazwa pola tabeli</v-list-tile-title>
          <v-list-tile-title
            style="width: 200px"
            class="list--el--bold"
          >Opcje
          </v-list-tile-title>
        </v-list-tile>
        <template v-for="(layer, index) in joinedLayers">
          <v-list-tile
            class="list--el"
            :key="index"
          >
            <v-list-tile-title>{{layer.name}}</v-list-tile-title>
            <v-list-tile-title>{{layer.join_meta.table}}</v-list-tile-title>
            <v-list-tile-title>{{layer.join_meta.layer_field}}</v-list-tile-title>
            <v-list-tile-title>{{layer.join_meta.table_field}}</v-list-tile-title>
            <v-list-tile-title style="width: 200px">
              <span>
                <v-icon
                  title="Edycja"
                  style="font-size: 16px;"
                  @click="editJoin(layer)"
                >edit</v-icon>
                <v-icon
                  title="Usuwanie"
                  style="font-size: 16px;"
                  @click="removeJoin(index)"
                >delete</v-icon>
              </span>
            </v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-flex>
  </Modal>
</template>

<script>

import Modal from '../../../shared/Modal';


export default {
  components: {
    Modal,
  },
  data: () => ({
    // userLayers: [{
    //   fields: [
    //     {
    //       data_type: "integer",
    //       name: "ogc_fid"
    //     },
    //     {
    //       data_type: "integer",
    //       name: "ID"
    //     },
    //     {
    //       data_type: "character varying",
    //       name: "proba.tata"
    //     },
    //     {
    //       data_type: "character varying",
    //       name: "proba.mama"
    //     },
    //     {
    //       data_type: "integer",
    //       name: "proba.ogc_fid"
    //     },
    //     {
    //       data_type: "character varying",
    //       name: "proba.id"
    //     }
    //   ],
    //   join_meta: {
    //     table: "proba",
    //     table_field: "ogc_fid",
    //     layer_field: "ogc_fid"
    //   },
    //   geometry_type: "linestring",
    //   name: "test_6",
    //   permission: 2,
    //   posted_by: 1,
    //   public: false,
    //   srid: 2178,
    //   table: "test_6.proba"
    // }]
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    userLayers() {
      return this.$store.getters.getUserLayers;
    },
    joinedLayers() {
      return this.userLayers.filter(layer => layer.join_meta)
    }
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    opened() {
      this.$store.dispatch("getUserLayers").then(success => {
        if(!success) {
          self.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania warstw użytkownika wystąpił błąd"
          );
        }
      })
    },
    removeJoin(index) {
      const self = this;
      this.$emit("confDialogOpened", true);
      self.$modal.show("dialog", {
        title: "Usuwanie warstwy użytkownika",
        text: "Czy na pewno chcesz usunąć złączenie?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$store.dispatch("editUserLayer", {
                table: this.joinedLayers[index].name,
                body: {
                  join_meta: null
                }
              }).then(success => {
                if(success) {
                  self.$root.$emit(
                    "showSnackbar",
                    "success",
                    "Pomyślnie usunięto złączenie"
                  );
                  this.$store.dispatch("getUserLayers")
                  // this.joinedLayers.splice(index, 1)
                } else {
                  self.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas usuwania złączenia wystąpił błąd"
                  );
                }
              });
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    editJoin(layer) {
      this.$root.$emit("editJoin",
        layer.name,
        layer.join_meta.table,
        layer.join_meta.table_field,
        layer.join_meta.layer_field
      )
    }
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/LayersJoin.vue